import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { selectors } from '@lbmx/app-state';
import {
  SpinnerService,
  ToastrNotificationService,
} from '@lbmx/phoenix-lib-utils';
import { BaseHttpService } from '@lbmx/root-services';
import { SearchContainerLoaderService } from '@lbmx/search-container';
import { toolKeys } from '@lbmx/types';
import { Request as BuilderRequest } from '@lbmx/web-core';
import { TranslocoService } from '@ngneat/transloco';
import { select, Store } from '@ngrx/store';
import { DialogService, DynamicDialogRef } from 'primeng';
import { ConfirmationService } from 'primeng-lts';
import { of, Subscription } from 'rxjs';
import { catchError, finalize, multicast, tap } from 'rxjs/operators';
import { apiUrls } from 'src/app/features/automations-module/url-config';
import { ConfigProvider } from 'src/app/provider/config-provider';

@Component({
  selector: 'app-member-account-rep',
  templateUrl: './member-account-rep.component.html',
  styleUrls: ['./member-account-rep.component.scss'],
  providers: [SearchContainerLoaderService, ConfirmationService, DialogService],
})
export class MemberAccountRepComponent {
  constructor(
    private translocoService: TranslocoService,
    private confirmationService: ConfirmationService,
    private toast: ToastrNotificationService,
    private spinner: SpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private configPrv: ConfigProvider,
    private http: BaseHttpService,
    private searchContainerLoaderService: SearchContainerLoaderService,
    private store: Store<any>,
    private dialogService: DialogService,
    private el: ElementRef
  ) {
    http.baseUrl = this.baseUrl;
  }

  public showAssignOptionsDialog = false;
  public showReassignOptionsDialog = false;
  public showRemoveDialog = false;
  public memberAccountRepDetailsConfig: BuilderRequest;
  public searchContainerName = 'memberAccountRepSearch';
  public showGenerateFileDialog = false;
  public columnActions = {};
  private subscriptions: Subscription[] = [];
  public email = '';
  public renderer: any;
  public i18nSearchField = 'ACTIONS.SEARCH_MEMBER_ACCOUNT_REP';
  public params: { [key: string]: any } = {};
  public baseUrl =
    `${this.configPrv.AppSetting?.uriAnalytics?.queryEndpoint}` +
    '/MemberAccountRep/member-account-rep';
  public memberAccountRepUrl = `${this.baseUrl}` + '/assign-options/form';
  public memberAccount2RepUrl = `${this.baseUrl}` + '/reassign-options/form';

  public selectedMember: any[];
  public selectedRep: any[] = [];
  public selections: any[];
  public members: Array<{ label: string; value: any }> = [];
  public reps: Array<{ label: string; value: any }> = [];

  public toolbarActionsDispatcher = {
    assign: (selection: any[]) => {
      // this.assignType = 1;
      this.showAssignOptionsDialog = true;
    },
    reassign: (selection: any[]) => {
      this.selectedMember = [...selection];
      this.showReassignOptionsDialog = true;
    },
    remove: (selection: any[]) => {
      this.selectedMember = [...selection];
      this.confirmationService.confirm({
        message: this.translocoService.translate(
          'ANALYTICS_REMOVE.REMOVE_RECORD_MESSAGE'
        ),
        header: this.translocoService.translate(
          'ANALYTICS_REMOVE.REMOVE_RECORD_HEADER'
        ),
        acceptLabel: this.translocoService.translate('ACTIONS.YES'),
        rejectLabel: this.translocoService.translate('ACTIONS.NO'),
        accept: () => {
          this.spinner.on();
          const selectedKeys = [...selection].map(
            ({ memberAccountRepAssignmentKey, ..._ }) =>
              memberAccountRepAssignmentKey
          );

          this.http
            .fetch({
              endpoint: apiUrls.delete(),
              httpMethod: 'POST',
              body: {
                MemberAccountRepAssignmentKey: selectedKeys,
              },
            })
            .pipe(
              tap(() => {
                this.toast.successNotify(
                  this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
                );

                this.searchContainerLoaderService.refreshSearch();
              }),
              catchError(() =>
                of(
                  this.toast.errorNotify(
                    this.translocoService.translate('MESSAGES.GENERIC_ERROR')
                  )
                )
              ),
              finalize(() => this.spinner.off())
            )
            .subscribe();
        },
        reject: () => {
          /* empty */
        },
      });
    },
    // remove: (selection: any[]) => {
    //   this.showRemoveDialog = true;
    // },
  };

  public closeAssignOptionsDialog() {
    this.showAssignOptionsDialog = false;
  }

  public updatecloseAssignOptionsDialog(): void {
    this.showAssignOptionsDialog = false;

    this.searchContainerLoaderService.refreshSearch();

    this.toast.successNotify(
      this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
    );
  }

  public updatecloseReassignOptionsDialog(): void {
    this.showReassignOptionsDialog = false;

    this.searchContainerLoaderService.refreshSearch();

    this.toast.successNotify(
      this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
    );
  }
  public closeReassignOptionsDialog(): void {
    this.showReassignOptionsDialog = false;
  }

  public openRemoveDialog(): void {
    this.showRemoveDialog = true;
  }

  public closeRemoveDialog(): void {
    this.showRemoveDialog = false;
  }
}
